export default __webpack_public_path__ + "static/media/warning--closed-lane-in-triple-lanes--g1.5e11cdf9.png";